import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const STATUS_UNREAD = 1;
const STATUS_READ = 2;

let _entities = [];

let NotificationStore = assign({}, EventEmitter.prototype, {

    emitChange: function()  {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    add: function(entity) {
        _entities.push(entity);
    },
    get: function(id) {
        return _entities[id];
    },
    getAll: function() {
        return _entities;
    },
    getAllUnread: function() {
        return _entities.filter((entity) => entity.statusId === STATUS_UNREAD);
    },
    count: function() {
        return _entities.length;
    }
});

NotificationStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.NOTIFICATION_LIST:
            _entities = action.data;
            NotificationStore.emitChange();
            break;

        case ActionTypes.NOTIFICATION_LIST_ERROR:
            NotificationStore.emitChange();
            break;

        case ActionTypes.NOTIFICATION_INFO:
            _entities[action.data.id] = action.data;
            NotificationStore.emitChange();
            break;

        case ActionTypes.NOTIFICATION_INFO_ERROR:
            NotificationStore.emitChange();
            break;

        case ActionTypes.NOTIFICATION_UPDATE:
            NotificationStore.update(action.data);
            NotificationStore.emitChange();
            break;

        case ActionTypes.NOTIFICATION_DELETE:
            NotificationStore.delete(action.data);
            NotificationStore.emitChange();
            break;

        default:
            break;

    }

});

export default NotificationStore;
